module.exports = __webpack_public_path__ + "img/avatar-20.cf98109e.png";